import { render, staticRenderFns } from "./PagesPath.vue?vue&type=template&id=76855614&scoped=true"
import script from "./PagesPath.vue?vue&type=script&lang=js"
export * from "./PagesPath.vue?vue&type=script&lang=js"
import style0 from "./PagesPath.vue?vue&type=style&index=0&id=76855614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76855614",
  null
  
)

export default component.exports